module.exports = __webpack_public_path__ + "static/media/ayana.294ffe5f.svg";